export enum QualificationStatusEnum {
	confirmed = 'confirmed',
	pending = 'pending',
}
